import React from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from '../../common/constants';
import Logo from './Logo';

interface AuthShellProps {
    children: React.ReactNode;
    footer?: React.ReactNode;
}

const AuthShell: React.FC<AuthShellProps> = ({ children, footer }) => (
    <div className="relative min-h-[calc(100vh-16rem)] flex items-center justify-center py-12 px-4 overflow-hidden">
        <div
            aria-hidden
            className="absolute inset-0 bg-[radial-gradient(circle,rgba(59,130,246,0.08)_1px,transparent_1px)] bg-[size:24px_24px]"
        />
        <div aria-hidden className="absolute -top-24 -left-24 w-80 h-80 rounded-full bg-teal-400/20 dark:bg-teal-600/10 blur-3xl" />
        <div aria-hidden className="absolute -bottom-24 -right-24 w-80 h-80 rounded-full bg-cyan-400/20 dark:bg-cyan-600/10 blur-3xl" />
        <div className="relative w-full max-w-md">
            <div className="flex justify-center mb-6">
                <Link to={ROUTES.HOME} className="flex items-center gap-3 group">
                    <Logo className="w-11 h-11 shadow-md group-hover:shadow-lg transition-shadow rounded-xl" />
                    <span className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Testam</span>
                </Link>
            </div>
            <div className="relative bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xl shadow-slate-200/50 dark:shadow-black/30 overflow-hidden">
                <div aria-hidden className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-teal-600 via-cyan-600 to-teal-600" />
                <div className="p-6 sm:p-8">{children}</div>
            </div>
            {footer && <div className="mt-6 text-center text-sm text-slate-500 dark:text-slate-400">{footer}</div>}
        </div>
    </div>
);

export default AuthShell;
